// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



import Vue from "vue";
import iView from "iview";
import "iview/dist/styles/iview.css";
import App from "./components/App";


import locale from "iview/dist/locale/ru-RU";
// import iView from 'view-design';
// import 'view-design/dist/styles/iview.css';
// import locale from 'view-design/dist/locale/ru-RU';

import router from "./router/index.js";
import VueAxios from "vue-axios";
import axiosInstance from "./api/axios.js";
import store from "./store/index.js";
import AsyncComputed from "vue-async-computed";
import { formatHttpError } from "./base/base_func";
// import { refreshState } from "./store/state";
// import VueTheMask from 'vue-the-mask'
//
// Vue.use(VueTheMask);
Vue.use(AsyncComputed);
Vue.use(iView, { locale });
// Vue.use(iView, {locale});
Vue.use(VueAxios, axiosInstance);


new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
  created() {
    this.$Message.config({
      duration: 7
    });

    // Восстанавливаем токены из хранилища (если они там есть).
    this.$store.dispatch("restoreTokensFromStorage", { vm: this });

    // Рефрешим токен либо редиректим на страницу входа

    let onAccessTokenFetched = access_token => {
      let subscribers = this.$store.state.refresh_subscribers;
      subscribers.map(callback => callback(access_token));
    };

    let addSubscriber = callback => {
      this.$store.commit("add_refresh_subscribers", callback);
    };

    let already_refreshing_token = false;

    this.$http.interceptors.response.use(null, error => {
      const {
        config,
        response: { status }
      } = error;
      const originalRequest = config;

      if (this.$route.meta.requiresAuth !== false) {
        // Отлавливаем запросы с инвалидным токеном и добавляем в массив для последующего повтора
        if (status === 401) {
          // Если токен не обновлялся - обновляем
          const refresh_token = localStorage.getItem('refresh_token');
          if (!already_refreshing_token && refresh_token) {
            this.$store.commit("clear_refresh_subscribers");
            // this.$store.commit("refreshing_token", true);
            already_refreshing_token = true;
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            this.$store
                .dispatch("refreshToken", { vm: this, refresh_token })
                .then(access_token => {
                  onAccessTokenFetched(access_token);
                })
                .catch(() => {
                  this.$router.push("/login");
                })
                .finally(() => {
                  // this.$store.commit("refreshing_token", false);
                  already_refreshing_token = false;
                });
          }

          return new Promise(resolve => {
            addSubscriber(access_token => {
              originalRequest.headers.Authorization = "Bearer " + access_token;
              resolve(this.$http(originalRequest));
            });
          });
        } else if (status === 511) {
          // Если ошибка аутентификации получена от LK - перенаправляем на страницу логина
          this.$router.push("/login");
        } else if (status === 403) {
          this.$Message.error('Доступ запрещен.');
          this.$router.go(-1);
        } else {
          let message = formatHttpError(status, error.response.data);
          this.$Message.error(message);
        }
      }


      return Promise.reject(error);
    });
  }
});



// WEBPACK FOOTER //
// ./src/main.js